angular
  .module('admin.directives')
  .directive('editOffice', editOffice);


function editOffice(){

  return {
    bindToController: {
      office: '=',
      onCancel: '&',
      onSaved: '&'
    },
    controller: editOfficeCtrl,
    controllerAs: 'ctrl',
    link: link,
    templateUrl: '/admin/templates/add-edit-office.html',
    restrict: 'E',
    scope: {}
  };

};


editOfficeCtrl.$inject = ['OfficeService', 'HelperService'];

function editOfficeCtrl(Service, helpers){
  var ctrl = this;

  return _.merge(ctrl, {
    remove: remove,
    isEditMode: true,
    setup: setup,
    submit: save
  });


  /////

  function setup(){
    if(!ctrl.office)
      return;

    ctrl.subject = parseForEditing(ctrl.office);
  };

  function onSave(){
    ctrl.loading = false;

    if(ctrl.onSaved)
      ctrl.onSaved();
  };

  function onError(errorMsg){
    ctrl.formError = errorMsg;
    ctrl.loading = false;
  };

  function parseForSave(office){
    var office = _.cloneDeep(office);
    var phones = [{
      which: 'office',
      number: helpers.formatPhone(office.phone),
    }];

    delete office.phone;
    office.phones = phones;

    return office;
  };

  function parseForEditing(office){
    var office = _.cloneDeep(office);

    if(office.phones && office.phones.length)
      office.phone = office.phones[0].number;

    return office;
  };

  function save(){
    var args = parseForSave(ctrl.subject);

    Service.save(args, ctrl.subject.id)
      .then(onSave)
      .catch(onError);
  };

  function remove(){
    if(!confirm('Delete ' + ctrl.subject.name + ' office?'))
      return;

    Service.remove(ctrl.subject.id)
      .then(onSave)
      .catch(onError);
  };

};


function link($scope, el, attrs, ctrl){
  $scope.$watchCollection('ctrl.office', ctrl.setup);
};
